import { render, staticRenderFns } from "./athletics-photo.vue?vue&type=template&id=9c34c97c&scoped=true&"
import script from "./athletics-photo.vue?vue&type=script&lang=js&"
export * from "./athletics-photo.vue?vue&type=script&lang=js&"
import style0 from "./athletics-photo.vue?vue&type=style&index=0&id=9c34c97c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c34c97c",
  null
  
)

export default component.exports